export const isDev = import.meta.env.MODE === "development";

const makeBankName = (): string => {
  return "Migom Bank";
};

export const bankName = makeBankName();
